export default __webpack_public_path__ + "static/media/PPI-steps-009.d361a340.jpg";